module.exports = __webpack_public_path__ + "static/media/help-circle.2098763b.svg";